import FormInput from "component/form/form_input";
import React from "react";
import { Button, Col, Divider, Form, Modal, Row } from "antd";
import { useSelector } from "react-redux";
import { defaultDebugOpenAddSelector } from "store/bailiff/(default)/debug/default_debug.selector";
import { useActionDefaultDebug } from "hook/base/debug/useActionDefaultDebug";
import { PlusOutlined } from "@ant-design/icons";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DialogDebugJob = () => {
  // -------------------------- VAR -----------------------------
  const { loading, handleCancel, handleAddJob } = useActionDefaultDebug();
  const [form] = Form?.useForm();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const open = useSelector(defaultDebugOpenAddSelector);
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      onCancel={() => handleCancel(form)}
      open={open}
      title="Thêm Job Debug"
      footer={null}
    >
      <Divider />
      <Form layout="vertical" form={form}>
        <Row>
          <Col xl={24} lg={24} md={24} xs={24}>
            <FormInput
              name="job"
              label="Tên Job"
              placeholder="Nhập Job id"
              rules={[{ required: true, message: "Vui lòng nhập tên job" }]}
            />
          </Col>
          <Divider />
          <Col align="right" xl={24} lg={24} md={24} xs={24}>
            <Button
              loading={loading}
              onClick={() => handleAddJob(form)}
              icon={<PlusOutlined />}
              type="primary"
              className="min-h-[40px] rounded-sm"
            >
              Thêm Job
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
export default DialogDebugJob;
